import * as React from "react";

import Page from "../components/Layout/Page";
import Container from "../components/Layout/Container";

const ResourcesPage = () => {
  return (
    <Page className="resources">
      <section className="hero">
        <Container>
          <h1>
            <strong>Privacy Policy</strong>
          </h1>
        </Container>
      </section>
      <section>
        <Container>
          <div style={{ textAlign: "center" }}>UNDER CONSTRUCTION</div>
        </Container>
      </section>
    </Page>
  );
};

export default ResourcesPage;
